import Divider from "components/common/Divider";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Bounce, toast } from "react-toastify";
import SocialAuthButtons from "./SocialAuthButtons";
import { useNavigate } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import { validateEmail } from "utils/Validations";
import { AdminLogin } from "api/endpoints";

import { useDispatch, useSelector } from "react-redux";
import { setUserData, setUserPermission } from "../../Redux/userSlice";

const LoginForm = ({ hasLabel, layout }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const loggedUserData = useSelector(state => state.DreamsAdminUser.userData);



  const [captcha, setCaptcha] = useState(true);

  const [error, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  // State
  const [formData, setFormData] = useState({
    email: loggedUserData?.loginId || '',
    password: loggedUserData?.password || '',
    remember: loggedUserData?.password ? true : false,
  });

  // Handler
  const handleSubmit = (e) => {
    e.preventDefault();

    // const validations = {};
    // if (!validateEmail(formData.email)) {
    //   validations.email = "Email not valid!";
    //   setErrors(validations);
    //   return;
    // }


    if (captcha) {
      
      setLoading(true);
      AdminLogin(formData.email, formData.password).then(res => {
        
        localStorage.setItem('UserAuthToken', res?.data?.token);
        localStorage.setItem('UserAuthTokenExpiry', res?.data?.expiry);
        dispatch(setUserData({...res?.data?.userInfo, password: formData.remember ? formData.password : ''}))
        dispatch(setUserPermission({}))

        toast.success(`Logged in as ${formData.email}`, {
          theme: "colored",
        });

        setLoading(false);
        navigate("/");

      }).catch(err => {

        setLoading(false);
        toast.error("Authentication failed.", {
          autoClose: 1000,
        });

      });


    } else {
      toast.error("Please Provide Captcha Verification", {
        autoClose: 1000,
      });
    }
  };

  const handleFieldChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group className="mb-3">
        {hasLabel && <Form.Label>Email address</Form.Label>}
        <Form.Control
          placeholder={!hasLabel ? "Email address" : ""}
          value={formData.email}
          name="email"
          onChange={handleFieldChange}
          type="email"
          className={`${error.email && "border border-danger"}`}
        />
        <div className="text-danger text-xs">{error.email}</div>
      </Form.Group>

      <Form.Group className="mb-3">
        {hasLabel && <Form.Label>Password</Form.Label>}
        <Form.Control
          placeholder={!hasLabel ? "Password" : ""}
          value={formData.password}
          name="password"
          onChange={handleFieldChange}
          type="password"
        />
      </Form.Group>

      <Row className="justify-content-between align-items-center">
        <Col xs="auto">
          <Form.Check type="checkbox" id="rememberMe" className="mb-0">
            <Form.Check.Input
              type="checkbox"
              name="remember"
              checked={formData.remember}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  remember: e.target.checked,
                })
              }
            />
            <Form.Check.Label className="mb-0 text-700">
              Remember me
            </Form.Check.Label>
          </Form.Check>
        </Col>


        <Col xs="auto">
          <Link
            className="fs-10 mb-0"
            to={`/forgot-password`}
          >
            Forgot Password?
          </Link>
        </Col>
      </Row>


      <ReCAPTCHA
        sitekey={process.env.REACT_APP_SECRET_KEY_CAPTCHA}
        onChange={(value) => setCaptcha(value)}
        className="mt-2"
      />

      <Form.Group>
        <Button
          type="submit"
          color="primary"
          className="mt-3 w-100"
          disabled={!formData.email || !formData.password || !captcha || loading}
          onClick={handleSubmit}
        >
          Log in{loading && '...'}
        </Button>
      </Form.Group>


    </Form>
  );
};

LoginForm.propTypes = {
  layout: PropTypes.string,
  hasLabel: PropTypes.bool,
};

LoginForm.defaultProps = {
  layout: "simple",
  hasLabel: false,
};

export default LoginForm;
